import { graphql, StaticQuery } from 'gatsby';
import Img from 'gatsby-image';
import React from 'react';
import styled from 'styled-components';

import { ChildImageSharp, LocationProps } from '../../interfaces';
import { decodeUri } from '../../utils/DecodeUri';
import { getKindergartenByPathname } from '../../utils/GetKindergartenByPathname';
import { findSocialUrl } from '../../utils/SocialUrl';
import { theme } from '../../utils/Theme';

interface FacebookHomeProps {
  data: Data;
  location: {
    pathname: string;
  };
}

interface Data {
  facebook: ChildImageSharp;
  instagram: ChildImageSharp;
  youtube: ChildImageSharp;
}

const StyledLink = styled.a`
  width: 33%;
  display: inline-block;
  padding: 20px;
  transition: filter 0.2s ease-out;
  vertical-align: middle;

  :hover {
    filter: brightness(120%);
  }

  ${theme.mediaQuerySizes.phone} {
    display: block;
    margin: auto;
    width: 50%;
  }

  ${theme.mediaQuerySizes.smallScreen} {
    width: 100%;
  }
`;

const Container = styled.div`
  width: 50%;
  padding: 20px;
  margin: 0 auto;
  ${theme.mediaQuerySizes.phone} {
    width: 80%;
  }
`;

const SocialLinks = (props: FacebookHomeProps) => {
  return (
    <Container>
      <StyledLink href={findSocialUrl(decodeUri(getKindergartenByPathname(props.location.pathname)), 'facebook')}>
        <Img alt="Facebook" fluid={props.data.facebook.childImageSharp.fluid} />
      </StyledLink>
      <StyledLink href={findSocialUrl(decodeUri(getKindergartenByPathname(props.location.pathname)), 'instagram')}>
        <Img alt="Instagram" fluid={props.data.instagram.childImageSharp.fluid} />
      </StyledLink>
      <StyledLink href={findSocialUrl(decodeUri(getKindergartenByPathname(props.location.pathname)), 'youtube')}>
        <Img alt="Youtube" fluid={props.data.youtube.childImageSharp.fluid} />
      </StyledLink>
    </Container>
  );
};

const query = graphql`
  query {
    facebook: file(relativePath: { eq: "icons/facebook-contact.png" }) {
      childImageSharp {
        fluid(maxWidth: 400, quality: 75) {
          ...GatsbyImageSharpFluid_withWebp_noBase64
        }
      }
    }
    instagram: file(relativePath: { eq: "icons/instagram-contact.png" }) {
      childImageSharp {
        fluid(maxWidth: 400, quality: 75) {
          ...GatsbyImageSharpFluid_withWebp_noBase64
        }
      }
    }
    youtube: file(relativePath: { eq: "icons/youtube-contact.png" }) {
      childImageSharp {
        fluid(maxWidth: 400, quality: 75) {
          ...GatsbyImageSharpFluid_withWebp_noBase64
        }
      }
    }
  }
`;

// eslint-disable-next-line react/display-name
export default ({ location }: { location: LocationProps }) => (
  <StaticQuery query={query} render={(data) => <SocialLinks data={data} location={location} />} />
);
